'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/math-intrinsics@1.1.0/node_modules/math-intrinsics/pow.js
// module id = ltwP
// module chunks = 0 64 65 66 67